/**
 * LogoSquadra — logo (TeamBadge) di una squadra, pescato da useSquadre.
 * Da affiancare al nome squadra dove serve solo il logo.
 */

import { useSquadre } from "../../hooks/useFase7";
import { TeamBadge } from "./TeamBadge";

export function LogoSquadra({
  squadraId,
  size = 26,
  className = "",
}: {
  squadraId: string;
  size?: number;
  className?: string;
}) {
  const { data: squadre } = useSquadre();
  const s = squadre?.find((x) => x.id === squadraId);
  if (!s) return null;
  return (
    <TeamBadge
      nome={s.nome}
      logoDataUrl={s.logo_data_url}
      size={size}
      variant="home"
      className={`!mx-0 shrink-0 ${className}`}
    />
  );
}
